import { cva as t } from "../../modules/index.es4.js";
const a = t(
  "z-50 min-w-[10rem] overflow-hidden rounded-lg border border-gray-400/50 bg-background p-3 text-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:bg-black dark:border-gray-200/10 dark:shadow-gray-700",
  {
    variants: {
      size: {
        default: "w-72",
        sm: "w-56",
        md: "w-72",
        lg: "w-95"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), o = t(
  "relative w-full flex cursor-default select-none items-center cursor-pointer space-x-2 rounded-lg px-2 py-1.5 text-sm outline-none transition-colors focus:bg-primary-50 focus:text-primary data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-background/50 dark:focus:text-foreground"
);
export {
  o as dropdownMenuContentItemVariant,
  a as dropdownMenuContentVariant
};
//# sourceMappingURL=DropdownMenu.styles.es.js.map
